import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const EditCity = () => {
  const [city, setCity] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [states, setStates] = useState([]);
  const { id } = useParams(); // Assuming the city ID is passed as a route parameter
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  useEffect(() => {
    // Fetch all states for the dropdown
    axios
      .get(`${API_BASE_URL}/states`)
      .then((resp) => {
        setStates(resp.data);
      })
      .catch((err) => console.error("Error fetching states:", err));

    // Fetch the specific city data
    axios
      .get(`${API_BASE_URL}/city/${id}`)
      .then((resp) => {
        console.log(resp);

        setCity(resp.data.city);
        setSelectedState(resp.data.stateId);
      })
      .catch((err) => console.error("Error fetching city:", err));
  }, [id, API_BASE_URL]);

  const handleEditCity = (e) => {
    e.preventDefault();
    axios
      .put(
        `${API_BASE_URL}/admin/cities/${id}`,
        { city, stateId: selectedState },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then(() => {
        alert("City updated successfully");
        navigate("/all-cities"); // Navigate back to the list of cities
      })
      .catch((err) => console.error("Error updating city:", err));
  };

  return (
    <div className="add-city-main-container">
      <div className="all-cities-heading-div">
        <h4>Edit City</h4>
        <div className="all-cities-nav-btns-div">
          <button
            className="nav-add-cities-form"
            onClick={() => navigate("/create-city")}
          >
            Add City
          </button>
          <button
            className="nav-all-cities-table"
            onClick={() => navigate("/all-cities")}
          >
            All Cities
          </button>
        </div>
      </div>

      <form className="add-city-form " onSubmit={handleEditCity}>
        <div className="city-input-group">
          <label>
            <b>State</b>
          </label>
          <select
            value={selectedState}
            onChange={(e) => setSelectedState(e.target.value)}
          >
            <option value="">--Select State--</option>
            {states.map((state) => (
              <option key={state._id} value={state._id}>
                {state.state}
              </option>
            ))}
          </select>
        </div>

        <div className="city-input-group">
          <label>
            <b>City</b>
          </label>
          <input
            type="text"
            placeholder="Enter City Name"
            value={city}
            onChange={(e) => setCity(e.target.value)}
          />
        </div>

        <div className="city-input-group-btns">
          <button type="submit">Update City</button>
          <button
            type="button"
            onClick={() => {
              setCity("");
              setSelectedState("");
            }}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditCity;
